import { createStyles, makeStyles } from '@mui/styles';
import { branding } from './branding';
import { colors } from '../utils/live-tracking';

export const useStyles = makeStyles(theme =>
  createStyles({
    form: { width: '100%', marginTop: theme.spacing(3) }, // signin spacing 3, forgotpassword spacing 1
    error: { color: '#f44336', fontWeight: 'bold', fontSize: '1.1em' }, // signin sin font*, productScreen es con otro color #d40707 y sin margen y sin font*
    button: {
      margin: theme.spacing(1),
      width: '20%'
    },
    buttonLiveTracking: {
      width: '100% !important',
      color: 'white !important'
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
      marginTop: '40px'
    },
    paperLiveTracking: {
      marginRight: theme.spacing(2)
    },
    create: { color: '#fff' },
    title: {
      color: '#555',
      fontWeight: 'normal',
      marginLeft: 10
    },
    hasError: {
      color: theme.palette.error.light
    }, // form-dropoff tiene flex, varios tienen dark y varios tienen #f00
    success: {
      color: 'rgb(0_107_33_/_87%)',
      fontWeight: 'bold',
      fontSize: '1.1em'
    }, // hay dos principales, uno a mano y un simple success light. form dropoff tiene flex, client y location create screen tiene modificadores y algunos de pricing usan un color particular
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)'
    },
    cardTittle: {
      fontSize: 14
    },
    pos: {
      marginBottom: 12
    },
    closed: {
      color: '#d40707',
      border: '2px solid #d40707'
    },
    empty: {
      color: '#000000b8',
      border: '2px solid #000000b8'
    },
    incomplete: {
      color: '#cece00',
      border: '2px solid #cece00'
    },
    completed: {
      color: 'green',
      border: '2px solid green'
    },
    routed: {
      color: 'green'
    },
    notRouted: { color: 'red' },
    dialogType: { background: theme.palette.primary.main, color: 'white' },
    gridStatus: {
      textAlign: 'left',
      marginLeft: '10px',
      marginRight: '10px',
      marginBottom: '8px',
      fontSize: '16px'
    },
    gridIcon: {
      justifyContent: 'flex-end',
      display: 'flex',
      alignItems: 'center'
    },
    icon: {
      color: 'black',
      cursor: 'pointer'
    }, // livetracking tiene black adicional
    iconActions: {
      paddingLeft: '5px'
    },
    content: {
      padding: '9px 10px'
    },
    modalBody: {
      paddingTop: '0.5rem',
      paddingBottom: '1.5rem'
    },
    space: {
      paddingBottom: '15px'
    },
    buttonAction: {
      margin: theme.spacing(1),
      color: 'white'
    },
    subTitle: {
      color: '#555',
      fontWeight: 'small',
      marginLeft: 10,
      paddingLeft: 15
    },
    notstarted: {
      color: 'blue',
      border: '2px solid blue'
    },
    datePicker: {
      paddingRight: '10px'
    }, // PreReservationByLastMileScreen tiene inline block
    toolbarFilter: {
      paddingLeft: 15,
      marginLeft: 'auto',
      marginRight: 0
    },
    dateFilter: {
      marginLeft: 10,
      paddingLeft: 15
    }, // Varios tiene margenes y padding en bottom adicional
    media: {
      height: '250px',
      width: '250px',
      borderRadius: '50%'
    }, // paginas de update de productos usan el mediaUpdate, falta actualizar en la fuente
    mediaUpdate: {
      height: '100%'
    },
    iconHeremap: {
      transform: 'translate(-40px,_-25px)',
      position: 'absolute',
      fontSize: '50'
    },
    count: {
      fontSize: '20px_!important',
      fontWeight: 'bold_!important'
    },
    gridInfo: {
      textAlign: 'left !important',
      display: 'inline-block !important',
      paddingLeft: '10px !important',
      paddingBottom: '10px',
      background: 'white'
    },
    type: {
      background: 'white !important',
      color: 'black !important'
    },
    gridContainer: {
      paddingBottom: '30px'
    },
    section: {
      padding: '14px'
    },
    p: {
      margin: '0px'
    },

    gridEvidence: {
      margin: '0px',
      height: '200px',
      padding: '10px'
    },
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center_center'
    },
    gridItem: {
      textAlign: 'left',
      marginLeft: '10px',
      marginRight: '20px',
      marginBottom: '8px',
      display: 'inline-block'
    },
    gridDriverInfo: {
      textAlign: 'left',
      marginLeft: '10px',
      marginRight: '20px',
      marginBottom: '8px',
      paddingTop: '8px',
      paddingBottom: '8px',
      display: 'inline-block'
    },
    hr: {
      width: '80%'
    },
    position: {
      fontSize: '20px',
      fontWeight: 'bold'
    },
    gridProduct: {
      minHeight: '4em',
      alignItems: 'center',
      textAlign: 'center'
    },
    gridEmpty: {
      minHeight: '5em',
      alignItems: 'center',
      textAlign: 'center'
    },
    gridDate: {
      background: 'white',
      color: '#2196F3'
    },
    gridDateDisabled: {
      background: 'white',
      color: '#787878'
    },
    strongDate: {
      paddingLeft: '0.5em'
    },
    gridDateTitle: {
      background: 'white',
      color: '#2196F3',
      fontSize: '18px'
    },
    rounded: {
      borderTop: `2px solid ${branding.mainColor}`,
      borderRadius: '5px',
      width: '70%'
    }, // ClientEvidences Screen usa widht 50%
    formControlClient: {
      width: '100%',
      marginBottom: '20'
    }, // consolidatedretirementscreen no usa margin bottom
    formControlSelect: {
      width: '100%',
      '& .MuiFormLabel-root': {
        color: 'rgb(23, 74, 124)',
        fontWeight: 'bold',
        fontSize: '0.94rem'
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: '1rem'
      },
      '& .MuiFormLabel-root.Mui-error': {
        color: theme.palette.error.main
      }
    },
    warningTitle: {
      color: 'red',
      fontWeight: 'normal',
      marginLeft: '10'
    },
    subTitle2: {
      color: '#555',
      fontWeight: 'small'
    },
    inputLabel: {
      padding: '0 4px',
      marginTop: '-8px'
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff'
    },
    palette: {
      primary: {
        main: 'primary'
      },
      secondary: {
        main: 'primary'
      }
    },
    containerCancelar: {
      padding: '1em'
    },
    text: {
      color: '#555',
      fontWeight: 'normal',
      marginLeft: 8
    },
    input: {
      display: 'none'
    },
    paperTime: {
      padding: '6px 16px'
    },
    secondaryTail: {
      backgroundColor: theme.palette.secondary.main
    },
    verticallyCenterContent: {
      margin: 'auto 0'
    },
    buttonActionBlack: {
      margin: theme.spacing(1),
      backgroundColor: 'black',
      color: 'white'
    },
    buttonActionGreen: {
      margin: theme.spacing(1),
      backgroundColor: 'green',
      color: 'white'
    },
    buttonActionPrimary: {
      margin: theme.spacing(1),
      backgroundColor: '#1C9996',
      color: 'white'
    },
    buttonActionSecondary: {
      margin: theme.spacing(1),
      backgroundColor: '#1F3444',
      color: 'white'
    },
    errorHelper: {
      color: '#f44336'
    },
    disabledButton: {
      backgroundColor: 'none'
    },
    rootAlert: {
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(2)
      },
      paddingTop: 15,
      paddingButton: 15
    },
    gridDialog: {
      padding: '10px'
    },
    FormLabelDialog: {
      padding: '10px'
    },
    items: {
      display: 'flex !important',
      alignItems: 'center !important'
    },
    header: {
      minHeight: '4em ',
      background: '#073043',
      color: 'white !important',
      paddingLeft: '15px !important',
      paddingRight: '15px !important'
    },
    search: {
      margin: '0 !important',
      background: 'white !important',
      borderRadius: '5px !important',
      left: 'auto !important',
      border: '0 px !important',
      width: '80% !important'
    },
    filter: {
      width: '100% !important',
      minHeight: '3em !important',
      float: 'left !important',
      position: 'relative !important'
    },
    menuList: {
      padding: '0px !important'
    },
    menuItem: {
      color: 'white !important',
      minHeight: '3em !important',
      fontSize: '13px !important',
      justifyContent: 'center !important'
    },
    popper: {
      width: '100% !important',
      position: 'absolute !important',
      left: 'auto !important',
      zIndex: '10 !important'
    },
    textField: { height: '34px !important' },
    typography: {
      border: '0 px !important',
      fontSize: '13px !important',
      color: 'black !important',
      textAlign: 'center !important',
      marginTop: '2px !important',
      marginLeft: '10px !important'
    },
    containerResult: {
      position: 'relative !important',
      height: '100% !important'
    }, // ProductReturnManagementScreen no tiene important
    inputAdornment: {
      border: '0 px !important',
      fontSize: '2px !important',
      height: '16px !important'
    },
    containerImg: {
      justifyContent: 'flex-end !important',
      height: '100% !important'
    },
    gridSearch: {
      background: colors.mustard,
      justifyContent: 'center !important',
      border: '0 px !important'
    },
    ListDrivers: {
      maxHeight: '80vh !important',
      overflowY: 'scroll !important',
      background: colors.gray
    },
    tableRow: {
      cursor: 'pointer'
    },
    notsuccess: {
      color: 'red',
      fontWeight: 'bold',
      paddingRight: '1rem'
    },
    loading: {
      color: 'rgb(0 107 33 / 87%)',
      fontWeight: 'bold',
      paddingRight: '1rem'
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main
    },
    block: {
      display: 'block',
      width: '100%',
      marginLeft: 10
    },
    submit2Travels: {
      margin: theme.spacing(2, 0, 2)
    },
    submit2: {
      color: 'white',
      width: 300,
      marginTop: 10,
      marginRight: 10,
      paddingRight: '5px'
    }, // travelscreen y userscreen usan dos valores distintos, falta cambiar en fuente
    submit_Type1: {
      color: 'white',
      width: 200,
      marginTop: 10,
      marginRight: 10
    }, // Este es un desastre, hay muchos submit, hay que revisarlos todos
    submit_Type2: {
      margin: theme.spacing(3, 0, 2)
    },
    submit_Type3: {
      margin: theme.spacing(4, 0, 2),
      color: 'white'
    },
    submit_Type4: {
      margin: theme.spacing(4, 0, 2)
    },
    submit_Type5: {
      margin: theme.spacing(2, 0, 2)
    },
    submit_Type6: {
      width: 300,
      marginTop: 10,
      marginRight: 10
    },
    root: {
      minWidth: 275
    }, // Revisar todos, aunque tienen tipos definidos
    rootLoading: {
      textAlign: 'center',
      verticalAlign: 'middle',
      marginTop: 40,
      marginBottom: 40
    }, // esta en loading y heremapreturn
    rootSignin: {
      height: '100vh'
    },
    rootLiveTracking: {
      display: 'flex !important'
    },
    formControlComponent: {
      margin: theme.spacing(1),
      minWidth: 120
    }, // varios componentes juegan con el minwidth, Modal join tiene width 100%
    formControl_Type1: {
      width: 300,
      marginBottom: 20
    },
    formControl_Type2: {
      width: '100% ',
      marginBottom: 20
    },
    containerItem: {
      position: 'relative',
      display: 'flex',
      flexWrap: 'wrap'
    }, // varios containers distintos, todos son particulares
    containerDriver: {
      minHeight: '5em !important',
      alignItems: 'center !important',
      textAlign: 'center !important',
      cursor: 'pointer !important'
    },
    containerProduct: {
      background: 'white',
      position: ' absolute',
      zIndex: '9',
      maxHeight: '100%',
      overflowY: 'scroll',
      borderLeft: '1px solid #707070',
      width: '33.4%'
    },
    containerReturn: {
      position: 'relative',
      display: 'flex',
      flexWrap: 'wrap'
    },
    itemMap: {
      position: 'absolute',
      left: '-25px',
      top: '-12px',
      color: 'white'
    }, // varios items distintos, todos son particulares
    itemProduct: {
      background: 'white',
      color: 'black'
    },
    itemReturn: {
      position: 'absolute',
      left: '-25px',
      top: '-12px',
      color: 'white'
    },
    gridDriverListDriver: {
      background: 'white !important',
      color: 'black !important'
    }, // dos distintos, todos son particulares
    gridDriverListProduct: {
      minHeight: '6em',
      alignItems: 'center',
      textAlign: 'center',
      fontSize: '16px',
      marginBottom: '-13px'
    },
    h5ListDriver: {
      marginBottom: '0px !important'
    },
    h5ListProduct: {
      marginBottom: '0px',
      marginRight: '5px',
      fontSize: '14px',
      display: 'inline-block'
    }
  })
);
